export default {
    defaultTemplate: undefined,
    templates: [],
    sendMessagesPayload: {
        to: "",
        template: ""
    },
    scheduledMessages: [],
    responseApi: null
};



// WEBPACK FOOTER //
// ./src/modules/whatsapp-api/state.js